export const noListingFoundError = 'No listing found for this id!';
export const download = 'download';
